import { getPacks } from '../peijian/all'

export default {
  name: 'igs-39',
  // 图文
  imageText: [
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-1.png',
    },
    {
      type: 'formwork9',
      list: [
        {
          id: 'a-1',
          text: '1、Powerful grow lights, talllamp arm, highwater capacity, large grow deck, and detachable trellis',
        },
        { id: 'a-2', text: '2、Grow up to 5 plants, 5x faster than soil' },
        { id: 'a-3', text: '3、10 W LED grow light for patent spectrum,optimallighting' },
        {
          id: 'a-4',
          text: '4、Adjusts for up to 16.3" of grow height soyou can grow big plants and features alarger bowl to hold more water than the base Harvest',
        },
        { id: 'a-5', text: '5、Touch-sensitive illuminated controlpanel & care indicators' },
        { id: 'a-6', text: '6、Easy, automatic reminders for water &plant food' },
      ],
    },
    // 模板5
    {
      type: 'formwork5',
      packs: getPacks([
        { id: 'accessories-1', num: 5 },
        { id: 'accessories-2', num: 5 },
        { id: 'accessories-3', num: 5 },
        { id: 'accessories-4', num: 5 },
        { id: 'accessories-11', num: 1 },
        { id: 'accessories-12', num: 1 },
        { id: 'accessories-17', num: 1 },
      ]),
    },
    {
      type: 'formwork6',
      specifications: [
        { id: '2-1', name: 'Product Specifications:', value: '220x135x110 (lowest)/415(hightest)mm' },
        { id: '2-2', name: 'Adapter Specifications Input:', value: '100V-240V/50-60HZ' },
        { id: '2-3', name: 'Colour:', value: 'Black / White / Red / Blue / Green' },
        { id: '2-4', name: 'Water Tank Capacity:', value: '1.5L' },
        { id: '2-5', name: 'Neludes:', value: '5pcs pod kit / 1 water pumps' },
        { id: '2-6', name: 'LED Light:', value: 'Specific Spectrum' },
        { id: '2-7', name: 'Color box Size:', value: '235x150x139mm' },
        { id: '2-8', name: 'Product Weight:', value: '1.0kg' },
        { id: '2-9', name: 'Output:', value: '5V' },
        { id: '2-10', name: 'Power:', value: '10W' },
        { id: '2-11', name: 'Number of Plants:', value: '5pods' },
        { id: '2-12', name: 'Product Type:', value: 'Hydroponic' },
        { id: '2-13', name: 'Lamp Beads:', value: 'White:30 Red:6 Blue:2' },
        { id: '2-14', name: 'Outer box Size:', value: '487×465x440mm' },
      ],
    },
    // 模板2
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-2.png',
    },
    // 模板7
    {
      type: 'formwork7',
      list: [
        {
          id: '3-1',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-peijian/zhichenggan.png',
          label: `At present,the world's highest hydroponic growing system with a height of 30 inches--- Adapt to more plants, including small and medium-sized can nabis`,
        },
        {
          id: '3-2',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-peijian/shuixiangshangai.png',
          label: `Up to 15 pods planting space---The plantin g is more function`,
        },
        {
          id: '3-3',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-peijian/dengzhao.png',
          label: `5. The first domestic mass-produced hydro ponicgrowing system with LCD display screen--More upscale`,
        },
        {
          id: '3-4',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-chanpingmaidian/APPkongzhi.png',
          label: `The WIFI APP version can be configured with Tuva mobile phoneremote operation and message reminder function---Value-added money,linked to technology`,
        },
        {
          id: '3-5',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-peijian/shuixiang+dizuo.png',
          label: `5.5L Large-capacity water tank---Can be usedfo r a lo nger time when filled with water`,
        },
        {
          id: '3-6',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-36/IGS-36-chanpingmaidian/shuibeng.png',
          label: `Users can change the design of the water pump by themselves tosolve the pain points ofthe industry.--Domestic patented technologycompletely solve the pain points, reduce the rate of negative reviews`,
        },
      ],
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-3.png',
    },
    // 模板8
    {
      type: 'formwork8',
      list: [
        {
          id: '4-1',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-shitu/igs-39-ceshitu.png',
        },
        {
          id: '4-2',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-shitu/igs-39-fanmian.png',
        },
        {
          id: '4-3',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-shitu/igs-39-fushitu.png',
        },
        {
          id: '4-4',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-39/IGS-39-shitu/igs-39-zhengshitu.png',
        },
      ],
    },
  ],
}
